import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Executions from './pages/Executions';
import ExecutionDetail from './pages/ExecutionDetail';
import Layout from './components/Layout';
import { useSessionTimeout } from './hooks/useSessionTimeout';
import '@/App.css';

// Wrapper component that uses session timeout
function AuthenticatedApp({ onLogout }) {
  useSessionTimeout(onLogout);
  
  return <Layout onLogout={onLogout} />;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
    setLoading(false);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
  };

  const handleLogout = useCallback(() => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={!isAuthenticated ? <Login onLogin={handleLogin} /> : <Navigate to="/" />}
        />
        <Route
          path="/"
          element={isAuthenticated ? <AuthenticatedApp onLogout={handleLogout} /> : <Navigate to="/login" />}
        >
          <Route index element={<Dashboard />} />
          <Route path="executions" element={<Executions />} />
          <Route path="executions/:executionId" element={<ExecutionDetail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
